import React from "react";
import { Outlet } from "react-router-dom";

const SecurityClearancePage: React.FC = () => {
  return (
    <div data-testid="security-clearance">
      <Outlet />
    </div>
  );
};

export default SecurityClearancePage;
